// extracted by mini-css-extract-plugin
export default {"additional":"FjDNlfFU","mobile":"_sBj9bgo","link":"VNtq1F2S"};